import _map from "lodash/map";
import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import Item from './Item';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Items = _ref => {
  let {
    items,
    languageOfTarget,
    maxOffset,
    setItemOffset
  } = _ref;
  return ___EmotionJSX(React.Fragment, null, _map(items, (item, index) => ___EmotionJSX(Draggable, {
    draggableId: item.id,
    index: index,
    key: item.id
  }, (providedDraggable, snapshotDraggable) => ___EmotionJSX(Item, {
    item: item,
    languageOfTarget: languageOfTarget,
    maxOffset: maxOffset,
    providedDraggable: providedDraggable,
    setItemOffset: setItemOffset,
    snapshotDraggable: snapshotDraggable
  }))));
};
export default Items;